import { StrictMode } from 'react'
import type { VFC } from 'react'
import { Theme, Spacing } from '@opallabs/gem'
import { Radio, ParagraphText, StrongText } from '@opallabs/lapidary'
import * as styles from '../styles'
import type { SidebarProps } from '../types'

export type Props = Pick<SidebarProps, 'theme' | 'visible'> &
  Readonly<{
    onChange: (isVisible: boolean) => void
  }>

export const VisibilitySection: VFC<Props> = ({
  onChange,
  theme = 'light',
  visible,
}) => {
  return (
    <StrictMode>
      <ParagraphText
        styleOverrides={{ marginInlineEnd: Spacing.S }}
        theme={theme}
      >
        <StrongText styleOverrides={{ fontSize: 14 }}>
          Slide Visibility
        </StrongText>
      </ParagraphText>

      <ParagraphText
        styleOverrides={{ marginInlineEnd: Spacing.S }}
        theme={theme}
      >
        Toggles whether this slide will show when playing this presentation.
      </ParagraphText>

      <div css={styles.field(theme as Theme)}>
        <Radio.Group
          defaultValue={visible.toString()}
          name="Slide Visibility"
          onChange={(e) => onChange(e.target.value === 'true')}
          theme={theme as Theme}
        >
          <Radio.Input label="Show" value="true" />
          <Radio.Input label="Hide" value="false" />
        </Radio.Group>
      </div>
    </StrictMode>
  )
}
VisibilitySection.displayName =
  'Hubble: VisibilitySection ← Sidebar ← SlideEditor'
